var angular = require('angular');

storage.$inject = ['$window'];

function storage($window) {

  var prefix = 'DIPlanGo.';

  function getItem(storage, key) {
    var value = storage.getItem((prefix + key));
    return value && angular.fromJson(value);
  }

  function setItem(storage, key, value) {
    storage.setItem(prefix + key, angular.toJson(value));
  }

  function removeItem(storage, key) {
    storage.removeItem(prefix + key);
  }

  this.local = {
    get: getItem.bind(null, $window.localStorage),
    set: setItem.bind(null, $window.localStorage),
    remove: removeItem.bind(null, $window.localStorage)
  };

  this.session = {
    get: getItem.bind(null, $window.sessionStorage),
    set: setItem.bind(null, $window.sessionStorage),
    remove: removeItem.bind(null, $window.sessionStorage)
  };

}

module.exports = storage;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/services/storage.js
 ** module id = 206
 ** module chunks = 1
 **/